import a from 'styled-components';
import { Indicator, Root } from '@radix-ui/react-progress';
import { jsx } from 'react/jsx-runtime';

var o=a(Indicator)`
  background: var(--progress-default);
  height: 100%;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  transition: 0.25s ease;
  background: ${({$variant:r})=>{switch(r){case"success":return "var(--color-green-600)";case"error":return "var(--color-pink-600)";case"warning":return "var(--color-yellow-600)";case"info":return "var(--color-blue-600)";default:return "var(--color-blurple-600)"}}};
`,t=a(Root)`
  height: 8px;
  min-width: 100px;
  border-radius: 100px;
  overflow: hidden;
  background: var(--color-neutral-100);

  &[data-value='100'] {
    ${o} {
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
  }
`;var i=({variant:r="default",max:n=100,value:e=0,...p})=>jsx(t,{max:n,value:e,"aria-label":"Progress bar",...p,children:jsx(o,{$variant:r,style:{width:`${e}%`}})});i.displayName="Progress";var m=a(i)``;

export { m as a };
